import Project from '../Project';

export default function Engineering({ handlePageChange }) {
  return (
    <div className='container'>
      <h1>Engineering</h1>

      <Project
        title='Stylophone'
        image='./assets/stylo_hero.png'
        onProjectClick={() => handlePageChange('Stylophone')}
      />
    </div>
  );
}
